import {Schema} from "rsuite";

const { ArrayType, DateType, NumberType, StringType } = Schema.Types;

const adminSkillModel = Schema.Model({
    skillName: StringType().isRequired('This field is required.'),
    skillType: StringType().isRequired('This field is required.'),
});

const adminSkillTypeModel = Schema.Model({
    skillTypeName: StringType().isRequired('This field is required.'),
});

const adminCertModel = Schema.Model({
    certName: StringType().isRequired('This field is required.'),
});

let now = new Date();
const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
const certModel = Schema.Model({
    certName: StringType().isRequired('This field is required.'),
    dateEarned: DateType().isRequired('This field is required.')
        .max(nextMonth, 'Cannot set certificate earned date to a date in the future'),
});

const educationModel = Schema.Model({
    degreeName: StringType().isRequired('This field is required.'),
    institution: StringType().isRequired('This field is required.'),
    major: StringType().isRequired('This field is required.'),
    minor: StringType(),
    dateEarned: DateType().isRequired('This field is required.')
});

const experienceModel = Schema.Model({
    position: StringType().isRequired('This field is required.'),
    company: StringType().isRequired('This field is required.'),
    startDate: DateType().isRequired('This field is required.'),
    endDate: DateType().isRequired('This field is required.')
        .addRule((value, data) => {
            if (data.startDate) {
                return value >= data.startDate;
            }
            return true;
        }, "End date must be after start date"),
});

const profileModel = Schema.Model({
    firstName: StringType().isRequired('This field is required.'),
    lastName: StringType().isRequired('This field is required.'),
    sellStatement: StringType(),
    clearance: StringType().isRequired('This field is required.'),
});


const projectModel = Schema.Model({
    expId: NumberType().isRequired('This field is required.'),
    projectName: StringType(),
    startDate: DateType().isRequired('This field is required.'),
    endDate: DateType().isRequired('This field is required.')
        .addRule((value, data) => {
            if (data.startDate) {
                return value >= data.startDate;
            }
            return true;
        }, "End date must be after start date"),
    description: StringType(),
    technologies: StringType(),
    responsibilities: StringType().isRequired('This field is required.'),
});

const skillModel = Schema.Model({
    skillName: StringType().isRequired('This field is required.'),
    skillType: StringType().isRequired('This field is required.'),
    skillExpLevel: StringType().isRequired('This field is required.'),
    yearsExp: NumberType()
        .isInteger('This field must be an integer')
        .isRequired('This field is required.')
});

const userModel = Schema.Model({
    email: StringType().isEmail().isRequired('This field is required.'),
    firstName: StringType().isRequired('This field is required.'),
    lastName: StringType().isRequired('This field is required.'),
    role: StringType().isRequired('This field is required.'),
    clearance: StringType().isRequired('This field is required.'),
});

const updateUserModel = Schema.Model({
    email: StringType().isEmail().isRequired('This field is required.'),
    firstName: StringType().isRequired('This field is required.'),
    lastName: StringType().isRequired('This field is required.'),
    role: StringType().isRequired('This field is required.'),
    clearance: StringType().isRequired('This field is required.'),
});

const basicQueryModel = Schema.Model({
    queryType: StringType().isRequired('This field is required.'),
    startDate: DateType(),
    endDate: DateType()
        .addRule((value, data) => {
            if (data.startDate) {
                return value >= data.startDate;
            }
            return true;
        }, "End date must be after start date"),
});

// subform schema models to validate onSubmit for reporting
const certsSubFormModel = Schema.Model({
    certName: StringType().isRequired('This field required'),
});
// these are not all required, we'll loop through and verify at least one is there
const degreeSubFormModel = Schema.Model({
    degreeName: StringType().isRequired('This field required'),
    institution: StringType().isRequired('This field required'),
    major: StringType().isRequired('This field required'),
    minor: StringType().isRequired('This field required'),
});
const experienceSubFormModel = Schema.Model({
    company: StringType().isRequired('This field required'),
});
const skillsSubFormModel = Schema.Model({
    skillName: ArrayType().isRequired('This field required'),
});
const externalApiSubFormModel = Schema.Model({
    queryField: StringType().isRequired('This field required'),
    operation: StringType().isRequired('This field required'),
    value: StringType().isRequired('This field required').minLength(1),
});
const yearsOfExpSubFormModel = Schema.Model({
    yoe: NumberType()
        .isInteger('This field must be an integer')
        .isRequired('This field is required.'),
    operation: StringType().isRequired('This field required'),
});


export {
    adminSkillModel,
    adminSkillTypeModel,
    adminCertModel,
    certModel,
    educationModel,
    experienceModel,
    profileModel,
    projectModel,
    skillModel,
    userModel,
    updateUserModel,
    basicQueryModel,
    certsSubFormModel,
    degreeSubFormModel,
    experienceSubFormModel,
    skillsSubFormModel,
    externalApiSubFormModel,
    yearsOfExpSubFormModel,
}